import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";

import "./css/index.css";

const App = lazy(() => import("./App"))

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <>
        <Suspense fallback={<>Loading...</>}>
            <App />
        </Suspense >
    </>
)